import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";

const pdf = (path) => encodeURI(path);

const tabs = [
  {
    id: "compliances",
    label: "Stock exchange Compliances",
    rows: [
      {
        id: "1",
        description: "Reg 74 Certificate of Dematerialization - 30 September 2026",
        link: pdf(
          "/assets/pdf/Corporate_Announcements/Reg_74_Certificate_of_Dematerialization_BOC_30-09-2026.pdf"
        ),
      },
    ],
  },
  {
    id: "announcements",
    label: "Stock exchange announcements",
    rows: [
      {
        id: "1",
        description: "Clarification on Price Movement to BSE",
        link: pdf(
          "/assets/pdf/Corporate_Announcements/Clarification_on_Price_Movement_to_BSE.pdf"
        ),
      },
      {
        id: "2",
        description: "Reg 13(3) Certificate of Dematerialization - 30 September 2026",
        link: pdf(
          "/assets/pdf/Corporate_Announcements/Reg_13_3_Certificate_of_Dematerialization_30-09-2026.pdf"
        ),
      },
      {
        id: "3",
        description: "Reg 27(2) Intimation - Q2 FY 2026-27",
        link: pdf(
          "/assets/pdf/Corporate_Announcements/Reg_27_2_Intimation_Q2_FY_2026-27.pdf"
        ),
      },
      {
        id: "4",
        description: "Regulation 76 Intimation - Q2 FY 2026-27",
        link: pdf(
          "/assets/pdf/Corporate_Announcements/Regulation_76_Intimation_Q2_FY_2026-27.pdf"
        ),
      },
      {
        id: "5",
        description: "Half yearly shareholding till Sept 2026 BOC",
        link: pdf(
          "/assets/Half yearly shareholding till Sept 2026 BOC.html"
        ),
      },
    ],
  },
];

const CorporateAnnouncements = () => {
  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const rows = tabs.find((tab) => tab.id === activeTab)?.rows || [];

  return (
    <>
      <Helmet>
        <title>Corporate Announcements</title>
      </Helmet>

      <div className="main-content">
        <Header />

        <div
          className="relative h-[30vh] sm:h-[40vh] md:h-[50vh] w-full bg-no-repeat bg-cover bg-center mb-3"
          style={{
            backgroundImage: `url(/assets/img/Financial_banner.png)`,
          }}
        >
          <div className="absolute left-4 sm:left-8 md:left-12 top-1/2 transform -translate-y-1/2 text-xl sm:text-3xl md:text-4xl lg:text-5xl font-normal text-white px-4 sm:px-8 md:px-20 font-serif">
            Corporate Announcements
          </div>
        </div>

        <h2 className="text-center text-lg sm:text-2xl font-semibold text-[#F26624] mb-4 px-4">
          CORPORATE ANNOUNCEMENTS
        </h2>

        <div className="w-[94%] md:w-[80%] lg:w-[70%] mx-auto mb-3 flex overflow-x-auto whitespace-nowrap gap-2 sm:gap-6 border-b border-gray-200">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`relative text-sm font-medium px-3 py-2 transition-colors ${
                activeTab === tab.id
                  ? "!text-[#F26624] !bg-transparent"
                  : "!text-gray-500 hover:text-gray-700 !bg-transparent"
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
              {activeTab === tab.id && (
                <span className="absolute left-0 bottom-0 w-full h-0.5 bg-[#F26624] rounded"></span>
              )}
            </button>
          ))}
        </div>

        <div className="w-[94%] md:w-[80%] lg:w-[70%] mx-auto border border-gray-300 mb-10 overflow-x-auto">
          <div className="bg-[#F26624] text-white text-sm font-medium py-2 px-1">
            <div className="flex">
              <div className="w-16 text-center border-r border-white/40">
                S.No
              </div>
              <div className="flex-1 text-center border-r border-white/40">
                Particulars
              </div>
              <div className="w-28 text-center">Link</div>
            </div>
          </div>
          {rows.length === 0 ? (
            <div className="bg-white text-sm text-gray-500 text-center py-6">
              No documents available.
            </div>
          ) : (
            rows.map((row) => (
              <div
                key={row.id}
                className="bg-white border-b border-gray-300 text-xs hover:bg-gray-50"
              >
                <div className="flex">
                  <div className="w-16 text-center border-r border-gray-300 py-2">
                    {row.id}
                  </div>
                  <div className="flex-1 px-3 py-2 border-r border-gray-300">
                    {row.description}
                  </div>
                  <div className="w-28 flex items-center justify-center">
                    <a
                      href={row.link}
                      target="_blank"
                      rel="noreferrer"
                      className="text-[#F26624] hover:text-red-800 hover:underline text-sm font-semibold"
                    >
                      Click Here
                    </a>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        <Footer />
      </div>
    </>
  );
};

export default CorporateAnnouncements;
